import React from 'react';
import spinner from '../../assets/spinner.svg';

const Loader = () => {
  return (
    <div className='spinner'>
      <img src={spinner} alt='' />
    </div>
  );
};

export default Loader;
